import { useQuery } from "react-query";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { ActionService } from "../../services/ActionService";
import { mdlSpoReportMarketListRequest } from "../../models/service-models/action/SpoReportMarketListRequest";

export type SpoMarketSelectProps = {
    hotelIds?: string[];
    onChange?: Function;
    value?: any;
    mode?: "multiple" | "tags" | undefined;
    defaultAllSelected?: boolean;
    formSetter?: Function;
}


export const SpoMarketSelect = (props: SpoMarketSelectProps) => {
    const { t } = useTranslation();

    const {
        data,
        isLoading,
        isError,
        refetch
    } = useQuery(
        ["getMarkets", props.hotelIds],
        () => {
            if (props.hotelIds) {
                var request: mdlSpoReportMarketListRequest = { hotelIds: props.hotelIds };
                return ActionService.ReportMarketList(request);
            }

        },
        {
            onSuccess(data) {
                if (props.defaultAllSelected) {
                    props.formSetter!("market", data?.body?.data?.map((market) => market.id!));
                }
            },
            refetchOnWindowFocus: false,
            enabled: !!props.hotelIds
        }
    );

    const onFocus = () => {
        let i;
        const el = document.getElementsByClassName(
            "ant-select-selection-search-input"
        );
        for (i = 0; i < el.length; i++) {
            el[i].setAttribute(
                "autocomplete",
                "registration-select"
            );
        }
    }

    let markets = data?.body?.data;

    const allSelectedValues = props.defaultAllSelected
        ? markets?.map((market) => market.id!)
        : undefined;

    return (
        <>
            <Select
                loading={isLoading}
                mode={props.mode}
                size="middle"
                onFocus={onFocus}
                maxTagCount={3}
                value={props.mode == "multiple" ? props.value ? props.value as string[] : props.defaultAllSelected ? data?.body?.data?.map((roomType) => roomType.id!) : undefined : props.value as string}
                onChange={(value: string | string[]) => props.onChange ? props.onChange(value) : undefined}
                showSearch
                placeholder={t("common.chooseRoomType")}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={markets?.map(h => Object.assign(h, {
                    label: h.name,
                    value: h.id
                }))}
            />
        </>
    )
}